export interface IClassroom {
    ocorrenciaNo: number;
    codigo: any;
    titulo: any;
    habilitado: boolean;
    escola: string;
}

